export const useFormatTime = (milleseconds: number) => {
  const seconds = new Date(milleseconds).getSeconds()
  return `${new Date(milleseconds).getMinutes()}:${("0" + seconds).slice(-2)}`
};

export type UseFormatTimeReturn = ReturnType<typeof useFormatTime>;

export default useFormatTime;
